import { getNumberLabel } from "@/utils/numberUtils";

/**
 * Formats a number for range labels, handling zero as a valid value.
 * Unlike getNumberLabel which treats 0 as falsy, this handles 0 explicitly.
 */
function formatRangeValue(
  value: number | undefined,
  options: { isCurrency?: boolean; compact?: boolean }
): string {
  if (value === undefined) return "";
  // Handle zero explicitly since getNumberLabel treats 0 as falsy
  if (value === 0) return options.isCurrency ? "$0" : "0";
  return getNumberLabel(value, options);
}

/**
 * Builds a formatted range label for numeric filters.
 *
 * @param min - Minimum value (optional)
 * @param max - Maximum value (optional)
 * @param options - Formatting options (isCurrency)
 * @returns Formatted range label (e.g., "> $1M", "$1M-$10M", "< 500")
 */
export function buildRangeLabel(
  min: number | undefined,
  max: number | undefined,
  options: { isCurrency?: boolean } = {}
): string {
  const labelOptions = {
    compact: true,
    ...(options.isCurrency ? { isCurrency: true } : {}),
  };

  if (min !== undefined && max === undefined) {
    return `> ${formatRangeValue(min, labelOptions)}`;
  }
  if (max !== undefined && min === undefined) {
    return `< ${formatRangeValue(max, labelOptions)}`;
  }
  if (min !== undefined && max !== undefined) {
    return `${formatRangeValue(min, labelOptions)}-${formatRangeValue(
      max,
      labelOptions
    )}`;
  }
  return "";
}
